// @file For playMode on tldraw canvas

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWhiteboardPlayModeStore = defineStore('whiteboardPlayMode', () => {
  const isPlayMode = ref(false)

  return {
    isPlayMode,
  }
})
